import { useRef, useState } from "react";
import { objSides, selectionDiv } from "../../Uitls/ComponentType";

export const useEditorMainPageState = ({ location }) => {
  const showToastRef = useRef(false);
  const [state, setState] = useState(location.state || {});

  const [isAspectRatioLocked, setIsAspectRatioLocked] = useState(false);
  const [isInfoPanel, setIsInfoPanel] = useState(false);
  const [froalatoolbarTag, setFroalatoolbarTag] = useState(true);
  const [popUpLeft, SetPopupLeft] = useState(-140);
  const [canvasUpdated, setCanvasUpdated] = useState(false);
  const [previousCanvasDimension, setPreviousCanvasDimension] = useState({});
  const [isImageDropped, setIsImageDropped] = useState(false);
  const [rhsUpdateTrigger, setRhsUpdateTrigger] = useState(0);
  const [addedActionsList, setAddedActionsList] = useState([
    { layerCompData: [] },
  ]);
  const [openModulesModal, setOpenModulesModal] = useState(false);
  const [openModulesScreen, setOpenModulesScreen] = useState(false);
  const [addedAnmationActionList, setAddedAnmationActionList] = useState([
    { animationObject: {} },
  ]);
  const [loadingModules, setLoadingModules] = useState(false);
  const [selectedPreviousId, setSelectedPreviousId] = useState("");
  const [listForReDo, setListForReDo] = useState([]);
  const [undoFlag, setundoFlag] = useState(true);
  const [undoCount, setUndoCount] = useState(0);
  const [openTimelinePopup, setOpenTimelinePopup] = useState({
    popupWindow: false,
    fromUnRedo: false,
  });
  const [undoAnimationObjFlag, setUndoAnimationObjFlag] = useState(true);
  const [refreshed, setRefreshed] = useState(false);
  const [layerLengthAtRefresh, setLayerLengthAtRefresh] = useState([]);
  const [refreshCompleted, setRefreshCompleted] = useState(0);
  const [MLRstatus, setMLRstatus] = useState("Not Submitted");
  const [contextMenuvisbility, setContextMenuvisibility] = useState(false);
  const [moduleClaimsData, setModuleClaimsData] = useState();
  const [mustUseData, setMustUseData] = useState([]);
  const [optionalModules, setOptionalModules] = useState([]);
  const [mustUseDataAvailable, setMustUseDataAvailable] = useState([]);
  const [droppedComponentTextIds, setDroppedComponentTextIds] = useState([]);
  const [copyPasteContextMenuPosition, setCopyPasteContextMenuPosition] =
    useState({ x: 0, y: 0 });
  const [copyPropertySelected, setCopyPropertySelected] = useState(false);
  const [selectedProperties, setSelectedProperties] = useState(null);
  const [selectedPropertiesIndex, setSelectedPropertiesIndex] = useState({
    index: null,
    keyIndex: null,
  });
  const [copyPasteContextMenuVisibility, setCopyPasteContextMenuVisibility] =
    useState(false);
  const [popUpValuesEdited, setPopUpValuesEdited] = useState(false);
  const [damsID, setDamsId] = useState("_");
  const [marker, setMarker] = useState(0);
  const [showModulesSection, setShowModulesSection] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const [isModuleExist, setIsModuleExist] = useState(false);

  const [multiSelect, setMultiSelect] = useState(selectionDiv);
  const [multiSelectedComps, setMultiSelectedComps] = useState([]);
  const [moduleStatuses, setModuleStatuses] = useState([]);

  const refMultiselected = useRef(multiSelectedComps);
  const [dataGraphichImgDropped, setDataGraphichImgDropped] = useState(false);
  const [bannerChanged, setBannerChanged] = useState(false);
  const [veevaModuleCardData, setVeevaModuleCardData] = useState([]);
  const [selectedSizeOptions, setSelectedSizeOptions] = useState([]);
  const [selectedBannerSize, setSelectedBannerSize] = useState("");
  const [veevaDocumentNumber, setVeevaDocumentNumber] = useState("");

  const [editComponent, setEditComponent] = useState();
  const [isEditorOnScrollbarItems, setIsEditorOnScrollbarItems] =
    useState("true");
  const [scrollbarItems, setScrollbarItems] = useState([]);
  const [canvasScrollHeight, setCanvasScrollHeight] = useState(0);
  const refBannerChanged = useRef(bannerChanged);
  const oneTimeValidationDocRef = useRef("");
  const [isOneTimeAsset, setIsOneTimeAsset] = useState(() => {
    try {
      if (Boolean(location?.state?.onetimeBanner)) {
        return true;
      }
      return JSON.parse(window.localStorage.getItem("oneTimeAsset") || "false");
    } catch (e) {
      return false;
    }
  });
  const [claimReferencesFootnotes, setClaimReferencesFoonotes] = useState([]);
  const refClaimReferencesFootnotes = useRef(claimReferencesFootnotes);
  const [scrollClaimReferencesFootnotes, setScrollClaimReferencesFoonotes] =
    useState([]);
  const refScrollClaimReferencesFootnotes = useRef(
    scrollClaimReferencesFootnotes,
  );
  const [notUsedEditorToggle, setNotUsedEditorToggle] = useState(false);

  const [layerChangedOnPause, setLayerChangedOnPause] = useState(true);
  const contextMenuRef = useRef([]);

  const [bannerData, setBannerData] = useState([]);
  const [openTimeLine, setOpenTimeLine] = useState(false);
  const [getAtom, setAtom] = useState({
    eventDetails: "",
    type: "",
    data: "",
    claimFootnotes: [],
    claimReferences: [],
    claimId: "",
    componentId: "",
    matchTextId: "",
    moduleIdIdentifier: "",
  });
  const [openTextWindow, setOpenTextWindow] = useState(false);
  const [openShapesWindow, setOpenShapesWindow] = useState(false);
  const [openModuleWindow, setOpenModuleWindow] = useState(false);
  const [openImageWindow, setOpenImageWindow] = useState(false);
  const [layerCompData, setLayerCompData] = useState([]);
  // Live palette draft for canvas preview: { id, backgroundColor?, border? }
  const [canvasStyleDraft, setCanvasStyleDraft] = useState(null);
  const [showPreview, setPreView] = useState(false);
  const [previewURl, setpreviewURl] = useState({});
  const [previewRedirectHome, setPreviewRedirectHome] = useState(false);
  const tempLayer = useRef(layerCompData);
  const tempLayerScrollbarItems = useRef(scrollbarItems);
  const editComponentRef = useRef(editComponent);
  const [moduleSearchExpression, setModuleSearchExpression] = useState({});
  const [removeSymbol, setRemoveSymbol] = useState(false);
  const [canvasDimension, setCanvasDimension] = useState({
    width: 0,
    height: 0,
    scale: 1,
    zoomValue: 100,
    fps: 60,
    backgroundColor: "rgba(255,255,255, 1)",
    globalLink: "https://",
    checkGloballink: false,
    checkLoops: false,
    loopAnimation: 0,
    custom: false,
    customTemp: false,
  });
  const [layerId, setLayerId] = useState({
    eventDetails: "",
    type: "",
  });

  const [layerIndex, setLayerIndex] = useState(undefined);
  const [animationObject, setAnimationObject] = useState({});
  const animationObjRef = useRef(animationObject);
  const [droppedComponentIds, setDroppedComponentIds] = useState([]);
  const [droppedTextIds, setDroppedTextIds] = useState([]);
  const [droppedTitleIds, setDroppedTitleIds] = useState([]);

  const [dimensionsData, setDimensionsData] = useState({
    dimensions: {
      dimension: ["W", "H"],
      positions: ["X", "Y"],
      width: "true",
      height: "true",
      xPosition: "true",
      yPosition: "true",
    },
  });
  const [containerID, setContainerID] = useState(undefined);
  const [currentIdZindex, setCurrentIdZindex] = useState(undefined);
  const createFroalaInstance = useRef([]);
  const [froalaIndex, setFroalaIndex] = useState(undefined);
  const [selectedComponent, setSelectedComponent] = useState({});
  const [count, setCount] = useState(0);
  const compCountRef = useRef(count);
  const [isVisible, setVisibility] = useState(false);
  const [showPaste, setShowPaste] = useState(false);
  const [toggleSelected, setToggleSelected] = useState(false);
  const [copiedComponent, setCopiedComponent] = useState("");
  const copiedComponentRef = useRef(copiedComponent);
  const [countZindex, setCountZindex] = useState(0);
  const refCountZindex = useRef(countZindex);
  const [checkedAspect, setCheckedAspect] = useState(false);
  const [checkedScroll, setCheckedScroll] = useState(false);
  const myStateRef = useRef(checkedAspect);
  const myCanvasRef = useRef(canvasDimension);
  const [modules, setModules] = useState([]);
  const [selectedModulecards, setSelectedModulecards] = useState([]);
  const tempSelect = useRef(selectedComponent);
  const scrollBarExpand = useRef([]);
  const [editModuleClicked, setEditModuleClicked] = useState(false);
  const [moduleSymbol, setmoduleSymbol] = useState("");
  const [bgColorCanvas, setBgColorCanvas] = useState({
    r: "255",
    g: "255",
    b: "255",
    a: "1",
  });
  const [genericInfo, setGenericInfo] = useState({
    bannerSize: "",
    Width: 0,
    Height: 0,
  });
  const [moduleCardsDataLHS, setModuleCardsDataLHS] = useState([]);
  const [playPause, setPlayPause] = useState({
    playPause: true,
    animationCompleted: true,
    complete: false,
  });
  const playPauseRef = useRef(playPause);

  const [verticalLineFor, setVerticalLineFor] = useState(objSides);

  const [addedCanvasActionsList, setAddedCanvasactionsList] = useState([]);
  const [canvasBgChange, setCanvasBgChange] = useState(false);

  const [isEditorOn, setIsEditorOn] = useState("notClickedYet");
  const [isDragged, setIsDragged] = useState({
    mouseDown: false,
    mouseMove: false,
    compDrag: false,
  });

  const [clickedTimes, setClickedTimes] = useState({ clicks: 0, index: null });
  const [isReferenceFootnotes, setisReferenceFootnotes] = useState(false);
  const [isReferenceFootnotesScrollbar, setisReferenceFootnotesScrollbar] =
    useState(false);
  const [claimsArray, setClaimsArray] = useState([]);
  const [reusableTextIdsArray, setReusableTextIdsArray] = useState([]);
  const refClaimsArray = useRef(claimsArray);
  const refReusableTextIdsArray = useRef(reusableTextIdsArray);
  const refDroppedTextIdsArray = useRef(droppedTextIds);
  const refDroppedComponentTextIds = useRef(droppedComponentTextIds);
  const refDroppedComponentIds = useRef(droppedComponentIds);
  const allMustUseDataEmpty = useRef(true);
  const undoStack = useRef([]);
  const redoStack = useRef([]);
  const [changeInEditor, setchangeInEditor] = useState(false);
  const [copiedKeyFrame, setCopiedKeyFrame] = useState("");
  const [popUpOptions, setPopUpOptions] = useState({
    ease: "NONE",
    opacity: 1,
    rotation: 0,
    scale: 1,
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    translateX: 0,
    translateY: 0,
    rotationX: 0,
    rotationY: 0,
    skewAnimation: false,
    end: 0,
    transformOriginX: 0,
    transformOriginY: 0,
    transformOriginZ: 0,
  });
  const [linkedModulesType, setLinkedModulesType] = useState();
  const [undoVersion, setUndoVersion] = useState(0);
  const [expanded, setExpanded] = useState({
    panel1: false,
    panel2: false,
    panel3: false,
    panel4: false,
    panel5: false,
    panel6: false,
    panel7: false,
    panel8: false,
    panel9: false,
    panel10: false,
    panel11: false,
    panel12: false,
    panel13: false,
  });
  const [toggleAnimatedBanner, setToggleAnimatedBanner] = useState(() =>
    Boolean(location?.state?.prefillIsAnimated),
  );
  const [showBannertype, setShowBannertype] = useState(() => {
    const routeState = location?.state || {};
    if (
      typeof routeState?.prefillBannerType === "string" &&
      routeState.prefillBannerType.trim()
    ) {
      return routeState.prefillBannerType;
    }
    if (typeof routeState?.prefillIsAnimated === "boolean") {
      return routeState.prefillIsAnimated ? "Animated" : "Static";
    }
    return "";
  });
  const [showBannerName, setShowBannerName] = useState(
    () => location?.state?.prefillBannerName || "",
  );
  const [showAssettype, setShowAssettype] = useState(
    () => location?.state?.prefillAssetType || "",
  );
  const [bannerValidationCheck, setBannerValidationCheck] = useState(false);
  const [draggerWidth, setDraggerWidth] = useState(675);
  const [zindexDelete, setZindexDelete] = useState(false);

  return {
    showToastRef,
    state,
    setState,
    isAspectRatioLocked,
    setIsAspectRatioLocked,
    isInfoPanel,
    setIsInfoPanel,
    froalatoolbarTag,
    setFroalatoolbarTag,
    popUpLeft,
    SetPopupLeft,
    canvasUpdated,
    setCanvasUpdated,
    previousCanvasDimension,
    setPreviousCanvasDimension,
    isImageDropped,
    setIsImageDropped,
    rhsUpdateTrigger,
    setRhsUpdateTrigger,
    addedActionsList,
    setAddedActionsList,
    openModulesModal,
    setOpenModulesModal,
    openModulesScreen,
    setOpenModulesScreen,
    addedAnmationActionList,
    setAddedAnmationActionList,
    loadingModules,
    setLoadingModules,
    selectedPreviousId,
    setSelectedPreviousId,
    listForReDo,
    setListForReDo,
    undoFlag,
    setundoFlag,
    undoCount,
    setUndoCount,
    openTimelinePopup,
    setOpenTimelinePopup,
    undoAnimationObjFlag,
    setUndoAnimationObjFlag,
    refreshed,
    setRefreshed,
    layerLengthAtRefresh,
    setLayerLengthAtRefresh,
    refreshCompleted,
    setRefreshCompleted,
    MLRstatus,
    setMLRstatus,
    contextMenuvisbility,
    setContextMenuvisibility,
    moduleClaimsData,
    setModuleClaimsData,
    mustUseData,
    setMustUseData,
    optionalModules,
    setOptionalModules,
    mustUseDataAvailable,
    setMustUseDataAvailable,
    droppedComponentTextIds,
    setDroppedComponentTextIds,
    copyPasteContextMenuPosition,
    setCopyPasteContextMenuPosition,
    copyPropertySelected,
    setCopyPropertySelected,
    selectedProperties,
    setSelectedProperties,
    selectedPropertiesIndex,
    setSelectedPropertiesIndex,
    copyPasteContextMenuVisibility,
    setCopyPasteContextMenuVisibility,
    popUpValuesEdited,
    setPopUpValuesEdited,
    damsID,
    setDamsId,
    marker,
    setMarker,
    showModulesSection,
    setShowModulesSection,
    isNext,
    setIsNext,
    isModuleExist,
    setIsModuleExist,
    multiSelect,
    setMultiSelect,
    multiSelectedComps,
    setMultiSelectedComps,
    moduleStatuses,
    setModuleStatuses,
    refMultiselected,
    dataGraphichImgDropped,
    setDataGraphichImgDropped,
    bannerChanged,
    setBannerChanged,
    veevaModuleCardData,
    setVeevaModuleCardData,
    selectedSizeOptions,
    setSelectedSizeOptions,
    selectedBannerSize,
    setSelectedBannerSize,
    veevaDocumentNumber,
    setVeevaDocumentNumber,
    editComponent,
    setEditComponent,
    isEditorOnScrollbarItems,
    setIsEditorOnScrollbarItems,
    scrollbarItems,
    setScrollbarItems,
    canvasScrollHeight,
    setCanvasScrollHeight,
    refBannerChanged,
    oneTimeValidationDocRef,
    isOneTimeAsset,
    setIsOneTimeAsset,
    claimReferencesFootnotes,
    setClaimReferencesFoonotes,
    refClaimReferencesFootnotes,
    scrollClaimReferencesFootnotes,
    setScrollClaimReferencesFoonotes,
    refScrollClaimReferencesFootnotes,
    notUsedEditorToggle,
    setNotUsedEditorToggle,
    layerChangedOnPause,
    setLayerChangedOnPause,
    contextMenuRef,
    bannerData,
    setBannerData,
    openTimeLine,
    setOpenTimeLine,
    getAtom,
    setAtom,
    openTextWindow,
    setOpenTextWindow,
    openShapesWindow,
    setOpenShapesWindow,
    openModuleWindow,
    setOpenModuleWindow,
    openImageWindow,
    setOpenImageWindow,
    layerCompData,
    setLayerCompData,
    canvasStyleDraft,
    setCanvasStyleDraft,
    showPreview,
    setPreView,
    previewURl,
    setpreviewURl,
    previewRedirectHome,
    setPreviewRedirectHome,
    tempLayer,
    tempLayerScrollbarItems,
    editComponentRef,
    moduleSearchExpression,
    setModuleSearchExpression,
    removeSymbol,
    setRemoveSymbol,
    canvasDimension,
    setCanvasDimension,
    layerId,
    setLayerId,
    layerIndex,
    setLayerIndex,
    animationObject,
    setAnimationObject,
    animationObjRef,
    droppedComponentIds,
    setDroppedComponentIds,
    droppedTextIds,
    setDroppedTextIds,
    droppedTitleIds,
    setDroppedTitleIds,
    dimensionsData,
    setDimensionsData,
    containerID,
    setContainerID,
    currentIdZindex,
    setCurrentIdZindex,
    createFroalaInstance,
    froalaIndex,
    setFroalaIndex,
    selectedComponent,
    setSelectedComponent,
    count,
    setCount,
    compCountRef,
    isVisible,
    setVisibility,
    showPaste,
    setShowPaste,
    toggleSelected,
    setToggleSelected,
    copiedComponent,
    setCopiedComponent,
    copiedComponentRef,
    countZindex,
    setCountZindex,
    refCountZindex,
    checkedAspect,
    setCheckedAspect,
    checkedScroll,
    setCheckedScroll,
    myStateRef,
    myCanvasRef,
    modules,
    setModules,
    selectedModulecards,
    setSelectedModulecards,
    tempSelect,
    scrollBarExpand,
    editModuleClicked,
    setEditModuleClicked,
    moduleSymbol,
    setmoduleSymbol,
    bgColorCanvas,
    setBgColorCanvas,
    genericInfo,
    setGenericInfo,
    moduleCardsDataLHS,
    setModuleCardsDataLHS,
    playPause,
    setPlayPause,
    playPauseRef,
    verticalLineFor,
    setVerticalLineFor,
    addedCanvasActionsList,
    setAddedCanvasactionsList,
    canvasBgChange,
    setCanvasBgChange,
    isEditorOn,
    setIsEditorOn,
    isDragged,
    setIsDragged,
    clickedTimes,
    setClickedTimes,
    isReferenceFootnotes,
    setisReferenceFootnotes,
    isReferenceFootnotesScrollbar,
    setisReferenceFootnotesScrollbar,
    claimsArray,
    setClaimsArray,
    reusableTextIdsArray,
    setReusableTextIdsArray,
    refClaimsArray,
    refReusableTextIdsArray,
    refDroppedTextIdsArray,
    refDroppedComponentTextIds,
    refDroppedComponentIds,
    allMustUseDataEmpty,
    undoStack,
    redoStack,
    changeInEditor,
    setchangeInEditor,
    copiedKeyFrame,
    setCopiedKeyFrame,
    popUpOptions,
    setPopUpOptions,
    linkedModulesType,
    setLinkedModulesType,
    undoVersion,
    setUndoVersion,
    expanded,
    setExpanded,
    toggleAnimatedBanner,
    setToggleAnimatedBanner,
    showBannertype,
    setShowBannertype,
    showBannerName,
    setShowBannerName,
    showAssettype,
    setShowAssettype,
    bannerValidationCheck,
    setBannerValidationCheck,
    draggerWidth,
    setDraggerWidth,
    zindexDelete,
    setZindexDelete,
  };
};

